import type { JSX } from 'react'

import type { NormalizedChannel } from '~publish/components/ChannelSelector'
import { FilterByChannelView } from '~publish/components/FilterByChannel'

export function PublicInsightsChannelFilter({
  channels,
  value,
  onChange,
}: {
  channels: NormalizedChannel[]
  value: string[]
  onChange: (ids: string[]) => void
}): JSX.Element {
  return (
    <FilterByChannelView
      channels={channels}
      value={value}
      onChange={onChange}
      onSelectAll={(): void =>
        onChange(value.length ? [] : channels.map((channel) => channel.id))
      }
      count={value.length}
    />
  )
}
